// extracted by mini-css-extract-plugin
module.exports = {"container":"Scroll06_container__3kB3Y","text":"Scroll06_text__2QnN0","photo":"Scroll06_photo__3XGMg","collage":"Scroll06_collage__3szub"};